import './modal-old.scss';
import { useEffect } from 'react';
import { X } from 'react-feather';
import classNames from 'classnames';
import {
  useCloseOldModal,
  useModalPosition,
  useModalComponentType,
  useModalUnmountCallbackThunk,
  useModalData,
} from '../../store/modal/modalHooks';
import ViewGymModal from './ViewGymModal';
import BookGymModal from './BookGymModal';
import ChangeGymRoom from './ChangeGymRoom';
import ViewRoomModal from './ViewRoomModal';
import ViewEventModal from './ViewEventModal';
import BookEventModal from './BookEventModal';
import DashboardAdModal from './DashboardAdModal';
import MedicalFormDeclaration from './MedicalForm';
import InviteVisitorModal from './InviteVisitorModal';
import AddCreditCardModal from './AddCreditCardModal';
import AddUserModal from './AddUserModal/AddUserModal';
import AddServiceCallModal from './AddServiceCallModal';
import BookRoomModal from './BookRoomModal/BookRoomModal';
import CreditUsageListModal from './CreditUsageListModal';
import RemoveUserModal from './QuestionModal/RemoveUserModal';
import EditGuestModal from '../pages/my-guests/EditGuestModal';
import ViewLoungeModal from './ViewLoungeModal/ViewLoungeModal';
import BookLoungeModal from './BookLoungeModal/BookLoungeModal';
import RemoveGuestModal from './QuestionModal/RemoveGuestModal';
import CancelAllocModal from './QuestionModal/CancelAllocModal';
import { ModalComponentEnum } from '../../store/modal/modalTypes';
import UploadMedicalCertificate from './UploadMedicalCertificate';
import RemoveWaitingList from './QuestionModal/RemoveWaitingList';
import EditUserModal from '../pages/user-management/EditUserModal';
import FailBookEventModal from './QuestionModal/FailBookEventModal';
import CancelBookEventModal from './QuestionModal/CancelEventModal';
import PurchaseSubscriptionModal from './PurchaseSubscriptionModal';
import DuplicateGuestModal from '../pages/my-guests/DuplicateGuestModal';
import CancelMembershipModal from './QuestionModal/CancelMembershipModal';
import RemoveCreditCardModal from './QuestionModal/RemoveCreditCardModal';
import FailOpenServiceCallModal from './QuestionModal/FailOpenServiceCallModal';
import NoMedicalDeclarationModal from './QuestionModal/NoMedicalDeclarationModal';
import DidGymTourModal from './QuestionModal/DidGymTourModal';
import MedicalFormSuccessModal from './MedicalFormSuccessModal/MedicalFormSuccessModal';
import InviteRepeatableVisitorModal from './InviteRepeatableVisitorModal';
import EditRepeatableGuestModal from '../pages/my-guests/EditRepeatableGuestModal';
import { RepeatGuestEndDateModal } from './RepeatGuestEndDateModal/RepeataGuestEndDateModal';

const ModalOld = () => {
  const closeModal = useCloseOldModal();
  const modalData = useModalData();
  const modalPosition = useModalPosition();
  const modalComponentType = useModalComponentType();
  const onModalUnmount = useModalUnmountCallbackThunk();

  useEffect(() => {
    return () => {
      onModalUnmount().finally();
    };
  }, []);

  const onCloseModal = () => {
    if (modalData?.cancelCallback) {
      modalData.cancelCallback();
    }

    closeModal();
  };
  return (
    <div className="modal-old-window">
      <div
        className={classNames('modal-content')}
        onClick={(e) => e.stopPropagation()}
        style={{
          top: modalPosition?.top,
          right: modalPosition?.right,
          left: modalPosition?.left,
          bottom: modalPosition?.bottom,
        }}
      >
        <button
          className="modal-content-close-icon"
          onClick={onCloseModal}
          aria-label="modal's close button"
        >
          <X />
        </button>
        <div className="model-body">
          {modalComponentType === ModalComponentEnum.BOOK_EVENT_MODAL && (
            <BookEventModal />
          )}
          {modalComponentType === ModalComponentEnum.BOOK_ROOM_MODAL && (
            <BookRoomModal />
          )}
          {modalComponentType === ModalComponentEnum.BOOK_GYM_ROOM_MODAL && (
            <BookGymModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.BOOK_FITNESS_EVENT_MODAL && <BookEventModal />}
          {modalComponentType === ModalComponentEnum.BOOK_LOUNGE_MODAL && (
            <BookLoungeModal />
          )}
          {modalComponentType === ModalComponentEnum.CHANGE_GYM_ROOM && (
            <ChangeGymRoom />
          )}
          {modalComponentType === ModalComponentEnum.FAIL_EVENT_BOOK && (
            <FailBookEventModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.QUESTION_REMOVE_GUEST_MODAL && (
            <RemoveGuestModal />
          )}
          {modalComponentType === ModalComponentEnum.INVITE_GUEST_MODAL && (
            <InviteVisitorModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.INVITE_REPEATABLE_GUEST_MODAL && (
            <InviteRepeatableVisitorModal />
          )}
          {modalComponentType === ModalComponentEnum.EDIT_GUEST_MODAL && (
            <EditGuestModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.EDIT_REPEATABLE_GUEST_MODAL && (
            <EditRepeatableGuestModal />
          )}
          {modalComponentType === ModalComponentEnum.NEW_SERVICE_CALL_MODAL && (
            <AddServiceCallModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.QUESTION_CANCEL_BOOK_EVENT_MODAL && (
            <CancelBookEventModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.QUESTION_CANCEL_ALLOC_MODAL && (
            <CancelAllocModal />
          )}
          {modalComponentType === ModalComponentEnum.VIEW_EVENT_MODAL && (
            <ViewEventModal />
          )}
          {modalComponentType === ModalComponentEnum.VIEW_ROOM_MODAL && (
            <ViewRoomModal />
          )}
          {modalComponentType === ModalComponentEnum.VIEW_LOUNGE_MODAL && (
            <ViewLoungeModal />
          )}
          {modalComponentType === ModalComponentEnum.VIEW_GYM_MODAL && (
            <ViewGymModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.QUESTION_FAIL_OPEN_SERVICE_CALL_MODAL && (
            <FailOpenServiceCallModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.OPEN_DASHBOARD_AD_MODAL && <DashboardAdModal />}
          {modalComponentType === ModalComponentEnum.ADD_CREDIT_CARD && (
            <AddCreditCardModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.QUESTION_REMOVE_CREDIT_CARD_MODAL && (
            <RemoveCreditCardModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.MEDICAL_FORM_DECLARATION_MODAL && (
            <MedicalFormDeclaration />
          )}
          {modalComponentType ===
            ModalComponentEnum.NO_MEDICAL_DECLARATION_MODAL && (
            <NoMedicalDeclarationModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.UPLOAD_MEDICAL_CERTIFICATE_MODAL && (
            <UploadMedicalCertificate />
          )}
          {modalComponentType ===
            ModalComponentEnum.GUEST_MANAGEMENT_DUPLICATE_GUEST && (
            <DuplicateGuestModal />
          )}
          {modalComponentType === ModalComponentEnum.ADD_USER_MODAL && (
            <AddUserModal />
          )}
          {modalComponentType === ModalComponentEnum.EDIT_USER_MODAL && (
            <EditUserModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.QUESTION_REMOVE_USER_MODAL && (
            <RemoveUserModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.QUESTION_CANCEL_WAITING_LIST_MODAL && (
            <RemoveWaitingList />
          )}
          {modalComponentType ===
            ModalComponentEnum.OPEN_CREDIT_USAGE_LIST_MODAL && (
            <CreditUsageListModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.PURCHASE_SUBSCRIPTION_MODAL && (
            <PurchaseSubscriptionModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.QUESTION_CANCEL_MEMBERSHIP_MODAL && (
            <CancelMembershipModal />
          )}
          {modalComponentType === ModalComponentEnum.CHECK_GYM_TOUR_MODAL && (
            <DidGymTourModal />
          )}
          {modalComponentType === ModalComponentEnum.CHECK_GYM_TOUR_MODAL && (
            <DidGymTourModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.MEDICAL_FORM_SUCCESS_MESSAGE_MODAL && (
            <MedicalFormSuccessModal />
          )}
          {modalComponentType ===
            ModalComponentEnum.REPEAT_GUEST_END_DATE_MODAL && (
            <RepeatGuestEndDateModal />
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalOld;
